import { mutatorAction } from 'satcheljs';
import type { PeopleRefinerSelection } from '../store/schema/PeopleRefinerSelection';
import getStore from '../store/store';

export const addToRefinerSelectionMutator: (selection: PeopleRefinerSelection) => void =
    mutatorAction('addToRefinerSelection', (selection: PeopleRefinerSelection): void => {
        const store = getStore();
        if (store.toRefinerSelections.some(item => item.id === selection.id)) {
            return;
        }

        store.toRefinerSelections.push(selection);
    });

export const removeToRefinerSelectionMutator: (selectionId: string) => void = mutatorAction(
    'removeToRefinerSelection',
    (selectionId: string): void => {
        const store = getStore();
        store.toRefinerSelections = store.toRefinerSelections.filter(
            selection => selection.id !== selectionId
        );
    }
);

export const setToRefinerSelectionsMutator: (selections: PeopleRefinerSelection[]) => void =
    mutatorAction('setToRefinerSelections', (selections: PeopleRefinerSelection[]): void => {
        getStore().toRefinerSelections = selections;
    });
